import {FC, useState} from 'react';
import {Box, Typography} from '@mui/material';
import Button from '@components/Button';
import UploadImage from '@/shared/components/UploadDropzone/UploadImage';
import {H6} from '@/utils/constants';
import {changePhotoModal} from './changePhotoModal.style';
import {OrganizationService, OrganizationTeamService} from '@/utils/services';
import axios from 'axios';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {
	changeProfile,
	getOrganizationInfo,
	getOrganizationSelector,
	getTeamMemberInfo,
	getTeamSelector,
} from '@/store/organization';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {IOrganization, ITeam} from '@/utils/types';
import { orgAPI } from '@/core/api';

interface ConfirmationModalProps {
	onCloseModal: () => void;
}
export const sendPresignedImage = async (presignedImgUrl: any, file: any) => {
	await axios.put(presignedImgUrl, file, {
		headers: {
			'Content-Type': file.type,
		},
	});
};
export const getImage = async (logo: File, type?: string) => {
	const presignedLogoUrl =
		type === 'organization'
			? await OrganizationService.presignOrganizationAvatar(orgAPI)
			: await OrganizationTeamService.presignedImage();

	await sendPresignedImage(presignedLogoUrl.data.url, logo);
	return presignedLogoUrl.data.key.split('/').pop();
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({onCloseModal}) => {
	const [avatar, setAvatar] = useState<File | null>(null);

	const organization: IOrganization | null = useAppSelector(getOrganizationSelector);
	const team: ITeam | null = useAppSelector(getTeamSelector);

	const dispatch = useAppDispatch();
	const handleLogoChange = (logo: File) => setAvatar(logo);

	const handleUploadProfileAvatar = async () => {
		if (!avatar) return;

		try {
			if (organization) {
				const logo = await getImage(avatar, 'organization');
				const reqBody = {...organization, logo};
				await dispatch(changeProfile(reqBody)).unwrap();
				await dispatch(getOrganizationInfo(organization?.id as number)).unwrap();

				onCloseModal();
			} else if (team) {
				const logo = await getImage(avatar, 'team');
				const reqBody = {
					id: team.id,
					firstName: team.firstName,
					lastName: team.lastName,
					email: team.email,
					logo,
				};
				await OrganizationTeamService.updateTeamMember(team.id as number, reqBody);
				await dispatch(getTeamMemberInfo(team?.id as number)).unwrap();

				onCloseModal();
			}
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	return (
		<Box sx={changePhotoModal.content}>
			<Typography variant={H6} sx={changePhotoModal.title}>
				Move and Scale
			</Typography>

			<Box sx={changePhotoModal.imagePickerWrap}>
				<UploadImage
					onChange={handleLogoChange}
					image={avatar}
					isImage
					parentClassName={changePhotoModal.imageLoader}
				/>
			</Box>
			<Box sx={changePhotoModal.btnWrap}>
				<Button variant="outline" sx={changePhotoModal.btn} onClick={onCloseModal} title="Cancel" />

				<Button sx={changePhotoModal.btn} onClick={handleUploadProfileAvatar} title="Confirm" />
			</Box>
		</Box>
	);
};

export default ConfirmationModal;
